import styled from '@emotion/styled';

const Margin = styled.div<{ vertical?: string, horizontal?: string }>`
  margin-top: ${({ vertical = '0px' }) => vertical};
  margin-left: ${({ horizontal = '0px' }) => horizontal};
`;

export default Margin;
